var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6C3.5 4.58579 3.5 3.87868 3.93934 3.43934C4.37868 3 5.08579 3 6.5 3C7.91421 3 8.62132 3 9.06066 3.43934C9.5 3.87868 9.5 4.58579 9.5 6C9.5 7.41421 9.5 8.12132 9.06066 8.56066C8.62132 9 7.91421 9 6.5 9C5.08579 9 4.37868 9 3.93934 8.56066C3.5 8.12132 3.5 7.41421 3.5 6Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18C3.5 16.5858 3.5 15.8787 3.93934 15.4393C4.37868 15 5.08579 15 6.5 15C7.91421 15 8.62132 15 9.06066 15.4393C9.5 15.8787 9.5 16.5858 9.5 18C9.5 19.4142 9.5 20.1213 9.06066 20.5607C8.62132 21 7.91421 21 6.5 21C5.08579 21 4.37868 21 3.93934 20.5607C3.5 20.1213 3.5 19.4142 3.5 18Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12H9.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3V8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6C15.5 4.58579 15.5 3.87868 15.9393 3.43934C16.3787 3 17.0858 3 18.5 3C19.9142 3 20.6213 3 21.0607 3.43934C21.5 3.87868 21.5 4.58579 21.5 6C21.5 7.41421 21.5 8.12132 21.0607 8.56066C20.6213 9 19.9142 9 18.5 9C17.0858 9 16.3787 9 15.9393 8.56066C15.5 8.12132 15.5 7.41421 15.5 6Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12H15.5C14.0858 12 13.3787 12 12.9393 12.4393C12.5 12.8787 12.5 13.5858 12.5 15M12.5 17.7692V20.5385M15.5 15V16.5C15.5 17.9464 16.2837 18 17.5 18C18.0523 18 18.5 18.4477 18.5 19M16.5 21H15.5M18.5 15C19.9142 15 20.6213 15 21.0607 15.44C21.5 15.8799 21.5 16.5881 21.5 18.0043C21.5 19.4206 21.5 20.1287 21.0607 20.5687C20.74 20.8898 20.2767 20.9766 19.5 21",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.9aabefc2609795addef0eb4818521618.svg";
export { ForwardRef as ReactComponent };